module.exports = __webpack_public_path__ + "img/moren.91d7f6f2.png";